import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
interface VaultV2PositionManagerDepositDialogLoadingProps {
  /** Hold the space of the "Pay with" row a wNative vault shows under the input. */
  reservesWrapRow?: boolean;
}
const VaultV2PositionManagerDepositDialogLoading = t0 => {
  const $ = _c(7);
  const {
    reservesWrapRow
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="gap-xs flex flex-col"><div className="flex flex-row justify-between"><Skeleton className="h-[26px] w-[170px] rounded-[20px]" /><Skeleton className="h-[26px] w-20 rounded-[20px]" /></div><Skeleton className="h-[87px] w-[100%] rounded-[20px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reservesWrapRow) {
    t2 = reservesWrapRow && <div className="mt-xs h-[28px]" />;
    $[1] = reservesWrapRow;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton className="h-[184px] w-[100%] rounded-[20px]" />;
    t4 = <Skeleton className="h-[48px] w-[100%] rounded-lg" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <div className="gap-md flex flex-col">{t1}{t2}{t3}{t4}</div>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default VaultV2PositionManagerDepositDialogLoading;